
import { defineComponent } from 'vue';
import Column from '../molecules/Column.vue';

export default defineComponent({
  components: { Column },
});
